import Layout from "./Layout";
import MessagingTopBar from "./MessagingTopBar";
import ShoutUI from "../shoutui";
import TopBarElement from "./TopBarElement";
import TranscriptArea from "./TranscriptArea";
import FooterArea from "./FooterArea";
import OverFlowItem from "./OverFlowItem";
import OverFlowMenu from "./OverFlowMenu";
import CustomerSimpleView from "./bubbleviews/CustomerSimpleView";
import AgentSimpleView from "./bubbleviews/AgentSimpleView";
import AgentBubble from "./bubbleviews/AgentBubble";
import CustomerBubble from "./bubbleviews/CustomerBubble";
import Typing from "./systemui/Typing";
import System from "./systemui/System";
import Header from "./systemui/Header";
import CloseModalView from "./systemui/CloseModal";
import EmailModalView from "./systemui/EmailModal";
import InfoModalView from "./systemui/InfoModalView";
import Disclaimer from "./systemui/DisclaimerMessage";
import SurveyTopBar from "./survey/SurveyTopBar";
import SurveyView from "./survey/Survey";
import RichView from "./bubbleviews/RichView";
import DisclaimerFooter from "./systemui/DisclaimerFooter";
import InputItem from "./InputItem";
import FooterButton from "./FooterButton";
import ExtendedFooter from "./ExtendedFooter";
import EmojiPicker from "./EmojiPicker";
import { CHAT_STATE, EMAIL_STATE } from "../model/Constants";
import AriaReaderView from "./AriaReaderView";
import FileUploadModalView from "./systemui/FileUploadModalView";
import VideoContainer from "./webrtc/VideoContainer";
import VideoStream from "./webrtc/VideoStream";
import PreCallInstructions from "./webrtc/PreCallInstructions";
import DeviceSettings from "./webrtc/DeviceSettings";

/**
 * Class initializes the ShoutUI web component framework
 * @class ShoutUIController
 */
class ShoutUIController {
    app: any;

    footerEl: any;

    layoutEl: any;

    transcriptEl: any;

    topBar: any;

    constructor(appInstance) {
        this.app = appInstance;
    }

    /**
     * Initializes the chat custom web elements with the ShoutUI Framework
     */
    initializeComponents() {
        const app = this.app;

        /**
         * ShoutUI is a light weight web components creation MVC framework
         */
        ShoutUI([
            MessagingTopBar(app),
            TopBarElement(app),
            TranscriptArea(app),
            FooterArea(app),
            OverFlowItem(app),
            OverFlowMenu(app),
            AgentSimpleView(app),
            CustomerSimpleView(app),
            AgentBubble(app),
            CustomerBubble(app),
            Typing(app),
            System(app),
            Header(app),
            CloseModalView(app),
            EmailModalView(app),
            InfoModalView(app),
            Disclaimer(app),
            SurveyTopBar(app),
            SurveyView(app),
            RichView(app),
            DisclaimerFooter(app),
            InputItem(app),
            FooterButton(app),
            ExtendedFooter(app),
            EmojiPicker(app),
            AriaReaderView(app),
            FileUploadModalView(app),
            VideoContainer(app),
            VideoStream(app),
            PreCallInstructions(app),
            DeviceSettings(app),
        ]);
    }

    /**
     * Render the initial chat Layout
     */
    kickInLayout() {
        ShoutUI(Layout(this.app));
    }

    /**
     * Create the top most div element that is used by ShoutUI framework to layout the chat. This is called after chat is closed
     */
    clear() {
        this.getFooter();

        if (this.footerEl) {
            this.footerEl.clear();
        }

        const el = document.createElement("div");
        el.setAttribute("id", "si-app");
        const curEl = this.layoutEl || document.querySelector("[ref-id='messaging-ui']");
        curEl.parentElement.replaceChild(el, curEl);

        this.transcriptEl = null;
        this.footerEl = null;
        this.topBar = null;
        this.layoutEl = null;
    }

    /**
     * Allows clients to dynamically change logo during an active chat
     * @param {object} logo
     */
    updateLogo(logo) {
        this.getTopBar().updateLogo(logo);
    }

    /**
     *
     * @return {MessagingTopBar}
     */
    getTopBar() {
        if (!this.topBar) {
            /**
             * @type {MessagingTopBar}
             */
            this.topBar = document.querySelector("messaging-top-bar");
        }
        return this.topBar;
    }

    resetTopBar() {
        this.topBar = null;
    }

    /**
     * Allows clients to dynamically change title during an active chat
     * @param {string} title
     */
    updateTitle(title) {
        this.getTopBar().updateTitle(title);
    }

    updateStatus(status, subStatus) {
        this.getTopBar().updateStatus(status, subStatus);
    }

    disableEmail() {
        this.app.getStateMgr().setState({ emailState: EMAIL_STATE.REQUESTED });
    }

    getLayoutEl() {
        if (!this.layoutEl) {
            this.layoutEl = document.querySelector("[ref-id='messaging-ui']");
        }
        return this.layoutEl;
    }

    hideSurveyOverflow() { // eslint-disable-line class-methods-use-this
        const el: any = document.querySelector("survey-top-bar");

        if (el) {
            el.hideOverflow();
        }
    }

    adjustTranscriptBottom(val) {
        this.getTranscriptEl().adjustBottom(val);
    }

    /**
     * @return {Transcript}
     */
    getTranscriptEl() {
        if (!this.transcriptEl) {
            /**
             * @type {Transcript}
             */
            this.transcriptEl = document.querySelector("transcript-area");
        }
        return this.transcriptEl;
    }

    /**
     * @return {Footer}
     */
    getFooter() {
        if (!this.footerEl) {
            /**
             * @type {Footer}
             */
            this.footerEl = document.querySelector("footer-area");
        }
        return this.footerEl;
    }

    /**
     * @return {integer}
     */
    getTopBarHeight() {
        return this.getTopBar().firstElementChild.clientHeight;
    }

    updateFullScreen(fullscreen) {
        this.getTopBar().toggleFullScreen(fullscreen);
    }
}

export default ShoutUIController;
